<footer class="footer">
  <div class="footer-container">
    <a
      class="wf-dark-green link-focus-shadow link-no-decoration"
      href="/accessibilitystatement"
      target="_blank"
      aria-label="Tillgänglighetsredogörelse"
      title="Denna länk navigerar dig till tillgänglighetsredogörelsen">
      Tillgänglighetsredogörelse
      <i class="fa-solid fa-up-right-from-square"></i>
    </a>
  </div>
</footer>
